import { render, staticRenderFns } from "./modern-minimalist.vue?vue&type=template&id=c0990594"
import script from "./modern-minimalist.vue?vue&type=script&lang=js"
export * from "./modern-minimalist.vue?vue&type=script&lang=js"
import style0 from "./modern-minimalist.vue?vue&type=style&index=0&id=c0990594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports